import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectFocusedInboxOption')(function selectFocusedInboxOption(isFocusedInboxEnabled, state) {
    var optionState = state.optionState;
    optionState.isEnabled = isFocusedInboxEnabled;
}));
//# sourceMappingURL=selectFocusedInboxOption.js.map